/**
 * tax.js — Canadian federal + Ontario provincial tax calculator.
 * Pure function — zero React.
 */
import { FHSA_ANNUAL, FHSA_LIFETIME } from '../constants/financial';

export function taxCA(income) {
  if (income <= 0) return { total: 0, fed: 0, prov: 0, cpp: 0, ei: 0 };
  let fed = 0, r1 = Math.max(0, income - 16129);
  for (const [w, rt] of [[57375,.15],[57375,.205],[62907,.26],[74825,.29],[Infinity,.33]]) {
    const t = Math.min(r1, w); fed += t * rt; r1 -= t; if (r1 <= 0) break;
  }
  let prov = 0, r2 = Math.max(0, income - 11865);
  for (const [w, rt] of [[53891,.0505],[53894,.0915],[42215,.1116],[70000,.1216],[Infinity,.1316]]) {
    const t = Math.min(r2, w); prov += t * rt; r2 -= t; if (r2 <= 0) break;
  }
  const cpp = Math.min(income * 0.0595, 4238) + Math.min(Math.max(0, income - 68500) * 0.04, 408);
  const ei = Math.min(income * 0.0163, 1123);
  const total = Math.max(0, fed + prov + cpp + ei);
  return { total, fed, prov, cpp, ei };
}
